import { useEffect } from "react";
import { useLoading } from "./state/LoadingContext";
import { Spinner } from "@wayfarer/components";

const LoadingFallback = () => {
  const { loading, setLoading } = useLoading();

  useEffect(() => {
    setLoading(true);
    return () => setLoading(false);
  }, [setLoading]);

  return <Spinner active={loading} />;
};

export default LoadingFallback;
